import Cookies from "js-cookie";

const cookieConfig = {
  path: import.meta.env.VITE_COOKIE_PATH,
  domain: import.meta.env.VITE_COOKIE_DOMAIN,
  expires: parseInt(import.meta.env.VITE_COOKIE_EXPIRES),
};

/**
 * Get a cookie value by key and parse it as JSON.
 * @param {string} key - The name of the cookie.
 * @returns {any} The parsed cookie value, or null if not found.
 */
export const get = (key) => {
  const value = Cookies.get(key);
  return value;
  // return value ? JSON.parse(value) : null;
};

/**
 * Set a cookie with a given key and value.
 * @param {string} key - The name of the cookie.
 * @param {any} value - The value to store in the cookie.
 */
export const set = (key, value) => {
  // Cookies.set(key, JSON.stringify(value), cookieConfig);
  Cookies.set(key, value);
};

/**
 * Remove a cookie by its key.
 * @param {string} key - The name of the cookie to remove.
 */
export const remove = (key) => {
  Cookies.remove(key);
  // Cookies.remove(key, cookieConfig);
};

/**
 * Clear a list of specific cookies (e.g., token).
 */
export const clear = () => {
  const cookiesToClear = ["token"];
  cookiesToClear.forEach((key) => {
    remove(key);
  });
};
